<template>
  <ContentSection>
    <Container
      class="-my-6 flex flex-wrap items-center"
      :class="
        data.orientation.value === 'left' ? 'flex-row' : 'flex-row-reverse'
      "
    >
      <div class="w-full py-6 md:w-1/2 md:px-6">
        <AppImage
          v-if="data.show_image_or_video.value === 'image'"
          :asset="data.image_file"
          class="aspect-[685/468] w-full bg-transparent object-contain"
          sizes="xs:90vw md:40vw"
        />

        <div v-if="data.show_image_or_video.value === 'video'">
          <VideoPlayer
            :video-id="videoId"
            :file="data.file"
            :poster="data.poster"
          />
        </div>
      </div>

      <div class="w-full py-6 md:w-1/2 md:px-6">
        <h2
          v-if="data.title"
          class="mb-4 text-md font-bold md:text-xl lg:text-2xl"
        >
          {{ data.title }}
        </h2>
        <Bard
          v-if="data.text"
          :content="data.text"
          class="text-pretty text-base font-normal"
        />
      </div>
    </Container>
  </ContentSection>
</template>

<script lang="ts" setup>
import type { AssetFragment } from '#gql'

const props = defineProps<{
  data: {
    title: string
    text?: string
    youtube_url?: string
    orientation: {
      value: string
    }
    show_image_or_video: {
      value: 'image' | 'video'
    }
    image_file?: AssetFragment
    file?: {
      permalink: string
    }
    poster?: {
      permalink: string
    }
  }
}>()

// Extract the video ID from the YouTube URL
const videoId = computed(() => {
  if (!props.data.youtube_url) return undefined

  const videoURL = props.data.youtube_url
  const splited = videoURL.split('v=')

  return splited[1]
})
</script>
